import React from 'react';
import { Box } from '@mui/material';
import NivoSchemeSelector from '../../../../../Components/Form/NivoSchemeSelector';
import { BlockSettingsProps } from './types';

export const OnlyUsersSettings: React.FC<BlockSettingsProps> = ({
    kedo,
    state,
    handleChangeSettings,
}) => {
    return (
        <Box sx={{ mt: 2 }}>
            <NivoSchemeSelector
                kedo={kedo}
                value={state.item.settings.scheme}
                onChange={(e: any) => handleChangeSettings('scheme', e.target.value)}
                name={'scheme'}
            />
        </Box>
    );
};